import VerifyCode from '@/components/Auth/VerifyCode'

const VerifyCodeScreen = () => {
  return <VerifyCode />
}

export default VerifyCodeScreen
